export default __webpack_public_path__ + "static/oldboyedu-290861f88bddee70e2f32351b9a0acb0.png";